import React, { useState, forwardRef, useImperativeHandle, useRef, useEffect } from 'react';
import CanvasHeader from '../../Common Components/Canvas_Header';
import './Task Creation.css';
import SingleSelectDropdown from '../../Common Components/SingleSelectDropdown';
import TaskComponents from './Task Components';
import TaskServiceController from '../../../Controllers/TaskService';


const TaskCreation = forwardRef((props, ref) => {
  // const TaskCreation = ({onBackClick,handleSelectChange,taskCategory,selectedOption}) => {
  let { onBackClick, handleSelectChange, taskCategory, selectedOption, onHandleSave, taskId, taskBody, onEdit, ...rest } = props;
  const [taskName, setTaskName] = useState(taskBody['taskName'] ?? '');
  const [taskParameter, setTaskParameter] = useState(null);
  const taskParameterRef = useRef(null);
  const [taskCategories, setTaskCategories] = useState([]);
  const [shouldReload, setShouldReload] = useState(false);
  const [selectedTaskCategory, setSelectedTaskCategory] = useState(selectedOption);

  const taskCont = new TaskServiceController();

  useEffect(() => {
    const getJsonData = async () => {
      const body = await taskCont.getTasksListforDropdown();
      setTaskCategories(
        Array.isArray(body) && body.length > 0
          ? body.map((item, index) => ({
            label: item.categoryName,
            value: item.categoryCode,
            description: item.description,
            id: item.id,
          }))
          : []
      );
    }

    getJsonData();
    setShouldReload(false);
  }, [shouldReload]);

  useEffect(() => {
    if (onEdit) {
      taskCategories.forEach((task) => {
        if (task.id === taskBody['taskCategoryId']) {
          handleSelectChange(task, true);
        }
        else {
          console.log('id not matching');
        }
      });
    }
  }, [taskCategories, onEdit]);


  const taskCreationJson = () => {
    if (!taskParameterRef.current) return;
    let taskParameterJson;
    const taskParameterValidation = taskParameterRef.current.saveValidations(selectedOption["value"]);
    setTaskParameter(taskParameterValidation);

    if (taskParameterValidation) {
      taskParameterJson = taskParameterRef.current.createJson(selectedOption["value"]);

      if (taskParameterJson) {
        if (taskName === "") {
          alert("Please specify a task name before saving");
          return;
        } else {
          const taskParameterObj =
            typeof taskParameterJson === "string" ? JSON.parse(taskParameterJson) : taskParameterJson;
          const taskJson = {
            taskName: taskName,
            taskCtgy: taskCategory,
            taskParameter: taskParameterObj,
            taskCtgyCode: selectedOption["value"]
          };

          return JSON.stringify(taskJson, null, 2);
        }
      }
    } else {
      console.log("Data did not pass validations", taskParameterJson);
    }
  };
  // const taskCreationJson = () => {
  //   if (taskParameterRef.current) {
  //     console.log("taskParameterRef.current (initial):",taskParameterRef.current );
  //     const taskParameterJson = taskParameterRef.current.createJson( selectedOption["value"] ); // Call the export function
  //     console.log("taskParameterJson (first call):", taskParameterJson);
  //     setTaskParameter(taskParameterJson);
  //     let checkEmptyValues;

  //     if(taskName === ''){
  //       console.log("task ctgy on save",taskCategory.value);
  //       alert(`Please specify a task name before saving`);
  //               }
  //           else if(taskCategory.value === 'BGColor'){
  //             if (taskParameterRef.current) {
  //               checkEmptyValues = taskParameterRef.current.validateFields();
  //               console.log("color parameters empty",checkEmptyValues);
  //               if(checkEmptyValues){
  //                 alert(`empty values pertaining to a row`);
  //               }
  //             } else {
  //               console.error("taskParameterRef.current is null");
  //             }

  //           }
  //           else{
  //             if (taskParameterJson) {
  //               // Now save the exported data
  //               // Perform your save operation here (e.g., send it to a server)

  //               // console.log("Saving task data:", taskParameterJson);
  //               // console.log("Saving task parameter:", taskParameter);
  //               // console.log("Saving task parameter:", selectedOption["value"]);

  //               // Ensure taskParameter is an object
  //               let taskParameterObj = taskParameterJson;
  //               if (typeof taskParameterJson === "string") {
  //                 taskParameterObj = JSON.parse(taskParameterJson);
  //               // console.log("task params obj:", taskParameterObj);
  //               }
  //               const taskJson = {
  //                 taskName: taskName,
  //                 taskCtgy: taskCategory,
  //                 taskParameter: taskParameterObj,
  //               };

  //               const jsonString = JSON.stringify(taskJson, null, 2);
  //               return jsonString;
  //             } else {
  //               console.log("No data to save task parameter");
  //             }
  //           }

  //   }
  // };

  useImperativeHandle(ref, () => ({
    taskCreationJson
  }));

  const handleChange = (event) => {
    setTaskName(event.target.value);
  }
  useEffect(() => {
    if (taskParameter) {
    }
  }, [taskParameter]);

  const [maxChars, setMaxChars] = useState(50);
  useEffect(() => {
    setMaxChars(50 - taskName.length);
  }, [taskName])

  return (
    <>
      <div style={{ padding: '10px' }}>
        <CanvasHeader backButtonLabel="Tasks List" backClick={onBackClick} event={true} saveJson={onHandleSave} workFlowId="0" clientId="0" handleSelectChange={handleSelectChange} />
      </div>
      <div style={{ padding: ' 10px', height: '75%', width: '98%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '10px', }}>
        <div style={{ background: '#F6F7FC', height: '100%', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'start', justifyContent: 'start', padding: ' 10px' }}>
          <p style={{ fontSize: '20px', fontWeight: "bold", color: '#121B45', margin: '10px 20px' }}>Task Creation</p>
          <div style={{ height: 'auto', width: '90%', background: '#FFF', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'start', padding: '10px', paddingBottom: "60px", paddingRight: "30px", margin: '0 25px', }}>
            <div>
              <div className='task-selection-grid'>
                <p className='task-name'>Task Name (<span style={{ fontSize: '15px', color: maxChars === 25 ? '#289e13' : '#ff0000' }}>{maxChars}</span> <span style={{ fontSize: '15px' }}>chars</span>)</p>
                <p className='task-category'>Task Category</p>
                <div >
                  <input className='task-name-input' onChange={handleChange} value={taskName} maxLength={50} />

                </div>
                <div className='task-category-dropdown'>
                  <SingleSelectDropdown options={taskCategories} onChange={handleSelectChange} valueSet={selectedOption} tskCtg={true} placeHolder={selectedOption['label'] ?? 'Select task category...'} isEdit={taskBody['taskCriteria'] ? true : false} />
                </div>
              </div>
            </div>

            <div style={{ height: 'auto', width: '100%', background: '#f3fbff', margin: '0px 10px' }}>
              <TaskComponents optionSet={taskCategory} onChange={handleSelectChange} selectedOption={selectedOption} ref={taskParameterRef} taskParams={taskBody['taskCriteria']} onEdit={onEdit} />
            </div>
          </div>
        </div>
      </div>
    </>
  )
});

export default TaskCreation;